<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('service.editVariant') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="group-edit-service-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('service.serviceName') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('service.serviceCode') }}:
            </label>

            <validation-provider
              rules="required"
              name="code"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="code" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('service.fromHowManyPiecesThePriceIsMultiplied') }}:
            </label>

            <validation-provider
              rules="required|min_value:0"
              name="price-multiple-from"
              v-slot="{ errors }">
              <d-input
                v-model="price_multiple_from"
                type="number"
                min="0"
                step="1"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <d-checkbox
              inline
              v-model="available_in_embriodery"
              toggle
              toggle-small
              class="mt-2 mb-0">
              {{ $t('service.availableInHafciarnia') }}
            </d-checkbox>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.saveChanges') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'group-edit-service-popup',
  props: {
    groupID: {
      default: 0,
      type: Number
    },
    serviceData: {
      default: () => ({}),
      type: Object
    }
  },
  data () {
    return {
      id: 0,
      name: '',
      code: '',
      price_multiple_from: '',
      available_in_embriodery: false
    };
  },
  mounted () {
    this.id = this.serviceData.id;
    this.name = this.serviceData.name;
    this.code = this.serviceData.code;
    this.price_multiple_from = this.serviceData.price_multiple_from;
    this.available_in_embriodery = !!this.serviceData.available_in_embriodery;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('group-edit-service-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['group-edit-service-form'], this.saveService);
    },
    saveService () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/services/update/' + this.id,
        formData: {
          group_id: this.groupID,
          name: this.name,
          code: this.code,
          price_multiple_from: this.price_multiple_from,
          available_in_embriodery: +this.available_in_embriodery
        },
        successTitle: this.$t('service.updateServiceSuccessTitle'),
        successText: this.$t('service.updateServiceSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('service.updateServiceErrorText'),
        successAction: () => {
          this.$bus.$emit('group-reload-services');
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
